import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/pt';

/**
 * Initialize dayjs plugins globally.
 * Import this module once at application startup to ensure all dayjs plugins are available.
 */
dayjs.extend(utc);
dayjs.extend(localizedFormat);
